<template>
  <div>
    <v-container fluid>
      <v-card elevation="0">
        <v-card-title class="secondary--text font-weight-medium pt-5">
          <v-row align="center" no-gutters class="">
            <v-col cols="12">
              <h3 class="my-2 primary--text">
                {{ $t("landlord.landlord") }}
              </h3>
            </v-col>
            <v-col cols="3">
              <v-text-field
                :label="$t('common.search')"
                v-model="search"
                :placeholder="$t('common.nameEmailPhone')"
                class="custom-label-color"
                hide-details="auto"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
            <v-col cols="9" class="text-end">
              <v-btn
                class="ml-2 white--text"
                color="primary"
                @click="openRightSideDrawer"
              >
                <v-icon class="mr-1"> mdi-plus-circle </v-icon>
                <span>{{ $t("landlord.addNew") }}</span>
              </v-btn>
              <v-btn
                @click="exportData"
                :loading="loadingDownload"
                class="ml-2 white--text"
                color="primary"
              >
                <v-icon class="mr-1"> mdi-application-export </v-icon>
                <span>{{ $t("common.excel") }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table
          :footer-props="{
            'items-per-page-options': [50, 100, 150, 200, -1]
          }"
          class="mt-1 datatable mb-9 table-reference-for-scroll"
          :headers="headers"
          :items="landlordLists"
          :hide-default-footer="footer"
          :search="search"
          :loading="loading"
          mobile-breakpoint="0"
          :options.sync="options"
          :server-items-length="totallandlord"
        >
          <template v-slot:[`item._id`]="{ item }">
            <p class="my-0 py-0">
              {{ item.slNo }}
            </p>
          </template>
          <template v-slot:[`item.avatar`]="{ item }">
            <v-row>
              <avatar
                v-if="item.avatar && !footer"
                class="mx-auto"
                :size="40"
                :src="`${$store.getters.imageBaseUrl}/${item.avatar}`"
              />
              <avatar
                v-else
                class="mx-auto"
                :username="item.user.firstName"
                :size="40"
              />
            </v-row>
          </template>
          <template v-slot:[`item.paymentTypes`]="{ item }">
            <template v-if="item.paymentTypes.length">
              <v-chip
                v-for="(i, j) in item.paymentTypes"
                class="green white--text"
                x-small
                :key="j"
                >{{ paymentTypeText[i] }}</v-chip
              >
            </template>
          </template>
          <template v-slot:[`item.name`]="{ item }">
            <router-link
              :to="{ name: 'LandLordDetails', params: { id: item._id } }"
            >
              {{
                `
                ${item.user.firstName} ${item.user.lastName}
                `
              }}
            </router-link>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-row justify="center" class="mx-auto">
              <!-- <v-icon color="primary" @click="editArea(item)"
                >mdi-pencil</v-icon
              > -->
              <v-icon color="red" @click="showDeleteDialog(item)"
                >mdi-delete</v-icon
              >
            </v-row>
          </template>
          <template v-slot:[`item.user.active`]="{ item }">
            <v-row justify="center" class="mx-auto">
              <LandlordStatus :item="item" />
            </v-row>
          </template>
          <template v-slot:[`item.user.nameEn`]="{ item }">
            <router-link
              :to="{ name: 'LandLordDetails', params: { id: item._id } }"
              >{{ item.user.nameEn }}</router-link
            >
          </template>
          <template v-slot:[`item.property`]="{ item }">
            <span v-if="item.property">
              {{ item.property.length }}
            </span>
            <span v-else> 0 </span>
          </template>
          <template v-slot:[`item.companyName`]="{ item }">
            <span v-if="item.companyName">
              {{ item.companyName }}
            </span>
            <span v-else> -- </span>
          </template>
          <template v-slot:[`item.endDate`]="{ item }">
            <td nowrap v-if="item.endDate">
              {{ dateFormat(item.endDate) }}
            </td>
            <span v-else> NIL </span>
          </template>
        </v-data-table>

        <v-data-table
          id="landlordTable"
          :headers="headers"
          :items="landlordExportList"
          v-show="false"
          :hide-default-footer="true"
          :items-per-page="-1"
        >
          <template v-slot:[`item._id`]="{ item }">
            <p class="my-0 py-0">
              {{ item.slNo }}
            </p>
          </template>
          <template v-slot:[`item.avatar`]="{ item }">
            <v-row>
              <avatar
                v-if="item.avatar && !footer"
                class="mx-auto"
                :size="40"
                :src="`${$store.getters.imageBaseUrl}/${item.avatar}`"
              />
              <avatar
                v-else
                class="mx-auto"
                :username="item.user.firstName"
                :size="40"
              />
            </v-row>
          </template>
          <template v-slot:[`item.paymentTypes`]="{ item }">
            <template v-if="item.paymentTypes.length">
              <v-chip
                v-for="(i, j) in item.paymentTypes"
                class="green white--text"
                x-small
                :key="j"
                >{{ paymentTypeText[i] }}</v-chip
              >
            </template>
          </template>
          <template v-slot:[`item.name`]="{ item }">
            <router-link
              :to="{ name: 'LandLordDetails', params: { id: item._id } }"
            >
              {{
                `
                ${item.user.firstName} ${item.user.lastName}
                `
              }}
            </router-link>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-row justify="center" class="mx-auto">
              <!-- <v-icon color="primary" @click="editArea(item)"
                >mdi-pencil</v-icon
              > -->
              <v-icon color="red" @click="showDeleteDialog(item)"
                >mdi-delete</v-icon
              >
            </v-row>
          </template>
          <template v-slot:[`item.user.active`]="{ item }">
            <v-row justify="center" class="mx-auto" v-if="item.user">
              {{ item.user.isActive == true ? "Yes" : "No" }}
            </v-row>
          </template>
          <template v-slot:[`item.user.nameEn`]="{ item }">
            <router-link
              :to="{ name: 'LandLordDetails', params: { id: item._id } }"
              >{{ item.user.nameEn }}</router-link
            >
          </template>
          <template v-slot:[`item.property`]="{ item }">
            <span v-if="item.property">
              {{ item.property.length }}
            </span>
            <span v-else> 0 </span>
          </template>
          <template v-slot:[`item.companyName`]="{ item }">
            <span v-if="item.companyName">
              {{ item.companyName }}
            </span>
            <span v-else> -- </span>
          </template>
          <template v-slot:[`item.endDate`]="{ item }">
            <td nowrap v-if="item.endDate">
              {{ dateFormat(item.endDate) }}
            </td>
            <span v-else> NIL </span>
          </template>
        </v-data-table>
      </v-card>
      <side-drawer>
        <template slot="formDetails">
          <landlord-form />
        </template>
      </side-drawer>
    </v-container>
  </div>
</template>

<script>
import LandlordStatus from "./LandlordStatus.vue";
import { deleteLandlord } from "../methods/delete_landlord";
import { formatDate } from "@/core/methods/formatDate";
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      loadingDownload: false,
      footer: false,
      search: "",
      variables: {
        limit: 50,
        skip: 0
      },
      options: {
        itemsPerPage: 50,
        page: 1
      },
      landlordLists: [],
      totallandlord: 10,
      landlordExportList: []
    };
  },
  components: {
    "side-drawer": () => import("@/core/components/SideDrawer"),
    "landlord-form": () => import("./rightSideDrawer/LandlordForm.vue"),
    LandlordStatus
  },
  computed: {
    paymentTypeText() {
      return {
        PAY_ONLINE: "Pay Online",
        PAY_AT_PROPERTY: "Pay at Property"
      };
    },
    headers() {
      return [
        {
          text: "#",
          align: "left",
          value: "_id",
          width: 10
        },
        {
          text: this.$t("landlord.nameEn"),
          align: "left",
          value: "user.nameEn",
          width: 150
        },
        {
          text: this.$t("landlord.nameAr"),
          align: "left",
          value: "user.nameAr",
          width: 150
        },
        {
          text: this.$t("landlord.email"),
          align: "left",
          value: "user.email",
          width: 150
        },
        {
          text: this.$t("landlord.phoneNumber"),
          align: "left",
          value: "user.phone",
          width: 150
        },
        {
          text: this.$t("landlord.companyName"),
          align: "left",
          value: "companyName",
          width: 150
        },

        {
          text: this.$t("landlord.isActive"),
          align: "left",
          value: "user.active",
          width: 100
        },

        {
          text: this.$t("common.actions"),
          value: "actions",
          align: "left",
          width: 100
        }
      ].map(header => {
        header.align = "center";
        header.sortable = false;
        return header;
      });
    }
  },
  watch: {
    search(val) {
      this.loading = true;
      this.$apollo.queries.getLandlords.refetch({
        input: {
          limit: 50,
          skip: 0
        },
        filter: {
          searchKey: val,
          sortDesc: false,
          sortBy: ""
        }
      });
      this.loading = false;
    },
    options: {
      handler() {
        this.variables.limit = this.options.itemsPerPage;

        this.variables.skip =
          this.options.page * this.options.itemsPerPage -
          this.options.itemsPerPage;
        this.landlordLists = [];
        this.$apollo.queries.getLandlords.refetch({
          input: {
            limit:
              this.options.itemsPerPage !== -1
                ? this.options.itemsPerPage
                : 500,
            skip: this.variables.skip
          },
          filter: {
            searchKey: this.search,
            sortBy: "",
            sortDesc: false
          }
        });
      },
      deep: true
    }
  },
  apollo: {
    getLandlords() {
      this.loading = true;
      return {
        query: require("@/landlord/api/queries/landlord_query.graphql"),
        fetchPolicy: "no-cache",
        variables: {
          input: {
            limit: this.variables.limit,
            skip: this.variables.skip
          },
          filter: {
            searchKey: this.search,
            sortBy: "",
            sortDesc: false
          }
        },
        result({ data, loading }) {
          this.loading = loading;
          if (!loading) {
            this.landlordLists = this.$format.cloneVariable(
              data.getLandlords.landlords
            );

            this.landlordLists.forEach((landlord, idx) => {
              landlord.slNo = this.variables.skip + idx + 1;
            });
            this.totallandlord = data.getLandlords.totalCount;
          }
        }
      };
    }
  },
  mounted() {
    this.$root.$on("deleteItems", data => {
      if (data.module === "landlord") {
        const input = data.item._id;
        deleteLandlord(input).then(data => {
          if (data.data.deleteLandlord) {
            this.$apollo.queries.getLandlords.refetch({
              input: {
                limit:
                  this.options.itemsPerPage !== -1
                    ? this.options.itemsPerPage
                    : 50,
                skip:
                  this.options.page * this.options.itemsPerPage -
                  this.options.itemsPerPage
              },
              filter: {
                searchKey: this.search,
                sortBy: "",
                sortDesc: false
              }
            });
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.deleteSuccess"),
              color: "green"
            });
            this.$store.commit("DELETE_BTN_LOADING", false);
          }
        });
      }
    });

    this.$root.$on("refetchLandlord", () => {
      this.$apollo.queries.getLandlords.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1 ? this.options.itemsPerPage : 50,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: this.search,
          sortBy: "",
          sortDesc: false
        }
      });
    });
  },
  methods: {
    dateFormat(date) {
      const rawDate = new Date(parseInt(date));
      return moment(rawDate, "YYYY-MM-DD").format("DD-MM-YYYY");
    },
    exportData() {
      this.loadingDownload = true;
      this.$apollo
        .watchQuery({
          query: require("@/landlord/api/queries/landlord_query.graphql"),
          variables: {
            input: {
              limit: 0,
              skip: 0
            },
            filter: {
              searchKey: this.search,
              sortBy: "",
              sortDesc: false
            }
          }
        })
        .refetch({
          input: {
            limit: 0,
            skip: 0
          },
          filter: {
            searchKey: this.search,
            sortBy: "",
            sortDesc: false
          }
        })
        .then(response => {
          if (response.data.getLandlords) {
            this.landlordExportList = response.data.getLandlords.landlords;
            this.landlordExportList.forEach((landlord, idx) => {
              landlord.slNo = this.variables.skip + idx + 1;
            });
            setTimeout(() => {
              this.loadingDownload = false;
              this.htmlToExcel("landlordTable", "landlord");
            }, 1000);
          }
          this.loading = false;
        });
    },
    showDeleteDialog(item) {
      this.$root.$emit("deleteDialog", {
        dialog: true,
        item: item,
        module: "landlord"
      });
    },
    openRightSideDrawer() {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    },
    showToggleDialog(item) {
      this.$root.$emit("toggleDialog", {
        dialog: true,
        item: item,
        module: "landlord"
      });
    },
    formatDate: formatDate
  },
  beforeDestroy() {
    this.$root.$off("landlordTable");
    this.$root.$off("deleteItems");
    this.$root.$off("refetchLandlord");
    this.$root.$off("toggleItems");
  }
};
</script>
<style scoped>
.datatable >>> .v-data-footer__select {
  direction: ltr !important;
}
.datatable >>> .v-data-footer__pagination {
  direction: ltr !important;
}

/* This is the size of the path of the scrollbar */
#wrapper2 {
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
}

/* This div allow to make the scroll function and show the scrollbar */
#top-scroll {
  height: 1px;
  overflow: scroll;
}

/* This is the size of the scrollbar */
.width-scroll-top {
  width: 2800px;
}
</style>
